import jwtDecode from 'jwt-decode'
import moment from 'moment'

export const isValidToken = (jwt) => {
  try {
    if (!jwt) {
      // console.log('cookie VACÍA!!!')
      return false
    }
    const claims = jwtDecode(jwt)
    if (claims.exp * 1000 < moment.now()) {
      return false
    }
    return true
  } catch (e) {
    return false
  }
}

export const isForgottenPassword = (url) => url.includes('password')
